import { useQuery } from '@tanstack/react-query'
import { DepositPromotionQueryKeys } from '../../../keys'
import { getDepositPromotionPresets } from '../../services'
import type { GetDepositPromotionPresetsResponse } from '../../../type'

export default function useQueryGetDepositPromotionPresets() {
	return useQuery<GetDepositPromotionPresetsResponse>({
		queryKey: [DepositPromotionQueryKeys.GetDepositPromotionPresets],
		queryFn: () => getDepositPromotionPresets(),
	})
}
